import posthog from "posthog-js";

export type JourneyPageKind =
  | "request"
  | "quote"
  | "order"
  | "switch_company"
  | "join_company"
  | "unavailable";

export const JOURNEY_KIND_PROPERTY = "journey_kind";

const JOURNEY_RECORD_PATH = /^\/dashboard\/orders\/[a-z0-9]{25,}\/?$/;

let capturingJourneyPageview = false;

function isJourneyRecordUrl(currentUrl: unknown): boolean {
  if (typeof currentUrl !== "string") return false;
  try {
    return JOURNEY_RECORD_PATH.test(new URL(currentUrl).pathname);
  } catch {
    return false;
  }
}

export function deferJourneyPageview<TEvent extends {
  event?: string;
  properties?: Record<string, unknown>;
} | null>(event: TEvent): TEvent | null {
  if (event?.event !== "$pageview" || capturingJourneyPageview) return event;
  return isJourneyRecordUrl(event.properties?.$current_url) ? null : event;
}

export function captureJourneyPageview(kind: JourneyPageKind): void {
  if (!posthog.__loaded) return;
  capturingJourneyPageview = true;
  try {
    posthog.capture("$pageview", { [JOURNEY_KIND_PROPERTY]: kind });
  } finally {
    capturingJourneyPageview = false;
  }
}
